export class PriceRuleLocationLocationView {
    public locationId: string;
    public locationName: string;
}